import React, {useEffect, useRef, useState} from 'react';
import {AuthLayout} from "../../../core/layout/AuthLayout";
import BtnPrimary from "../../../shared/ui/button/primary/BtnPrimary";
import {FormElements} from "../../../shared/ui/form/FormElements";
import {StructureFormModel} from "../../../shared/ui/form/models/FormModule";
import {formControlTypes} from "../../../shared/ui/form/models/formControlTypes";
import {useForm} from "../../../shared/utils/forms/useForm";
import {useSelector} from "react-redux";
import {selectSelectedPharmacy} from "../../../core/reducer/pharmacySlice";
import http from "../../../shared/utils/http";
import {exportPdf} from "../../../shared/utils/exportPdf";
import {months, monthsArrayOpt} from "../../../core/data/date";
import {dateFormatGG} from "../../../shared/utils/dateUtils";


export function Prospect() {
    const pharmacy = useSelector(selectSelectedPharmacy)
    const isTimeBank = !!pharmacy?.timeBank;
    const [data, setData] = useState<any>(undefined);
    const [columns, setColumns] = useState<any>([]);
    const printHandler = () => {
        setPrintView(true)
    }
    const structureDataTypeHour: StructureFormModel[] = [
        {
            type: formControlTypes.select,
            name: "year",
            options: Array.from({length: new Date().getFullYear() - 2024 + 1}, (_, i) => new Date().getFullYear() - i).map(y => ({label: String(y), value: String(y)})),
            dataElement: {
                placeholder: "Seleziona anno",
                type: 'text',
                defaultValue: {label: 'Seleziona Anno', isDefault: true, disabled: true},
            },
            col: {xs: "12", sm: "3"},
        },
        {
            type: formControlTypes.select,
            name: "month",
            options: monthsArrayOpt,
            dataElement: {
                placeholder: "Seleziona mese",
                type: 'text',
                defaultValue: {label: 'Seleziona Mese', isDefault: true, disabled: true},

            },
            col: {sm: "4"},
        },
    ]

    const submitHandler = (event: any, data: any) => {
        http.get(`pharmacies/${pharmacy?.idDocument}/prospect/${data.month}/${data.year}`).then(res => {
            setData(res.infos)
            setColumns(res.days)
        })
    }
    const {
        dataFormatted,
        dataForm,
        errors,
        isSubmit,
        changeValue,
        submitAction
    } = useForm(submitHandler)

    const [printView, setPrintView] = useState<boolean>(false)

    const pdfRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (printView) {
            exportPdf(`${pharmacy?.name}_statistiche`, pdfRef, () => {
                window.close()
                setPrintView(false)
            }, {format: 'a1'})
        }
    }, [printView]);

    return (
        <AuthLayout>
            <div className="row" ref={pdfRef}>
                <div className="col pt-3">
                    <div className={'d-flex justify-content-between align-items-center'}>
                        <div className={'d-flex align-items-center gap-3 w-100'}>
                            <h3 className={'text-nowrap mb-4'}>Prospetto</h3>
                        </div>
                        <div className={'d-flex gap-2 w-100'}>
                            <div className={'ms-auto w-100'}>
                                <FormElements structure={structureDataTypeHour} changeValue={changeValue}
                                              dataForm={dataForm}
                                              style={{justifyContent: 'end'}}
                                              errors={errors} isSubmit={isSubmit}/>
                            </div>
                            {!printView &&
                                <div className={'d-flex gap-2'}><BtnPrimary title="Filtra"
                                                                            icon={'./assets/icons/filter.svg'}
                                                                            disabled={false}
                                                                            variant={'primary'}
                                                                            onClick={() => submitAction()}></BtnPrimary>
                                    <BtnPrimary title="Stampa" icon={'./assets/icons/print.svg'} disabled={false}
                                                variant={'outline-primary'} className={'text-cyan-500 border-cyan-500'}
                                                onClick={() => printHandler()}></BtnPrimary>
                                </div>}
                        </div>
                    </div>

                    {data ? <div className="col">
                        <h5>
                            {months[dataFormatted.month] ? `${months[dataFormatted.month]} - ${dataFormatted.year}` : ''}
                        </h5>
                        <table className={'table-print'}>
                            <thead>
                            <tr>
                                <th>Nominativo</th>
                                <th></th>
                                {columns?.map((col: any) => {
                                    const a = dateFormatGG(new Date(col.year, col.month, col.day))
                                    return <th>{a}</th>
                                })}
                            </tr>
                            </thead>
                            <tbody>
                            {data?.map((info: any) => (
                                <>
                                    <tr style={{borderColor: 'transparent'}}>
                                        <td rowSpan={2}
                                            style={{border: '1px solid gray'}}>{info?.employee.name} {info?.employee.surname}</td>
                                        <td style={{border: '1px solid gray'}}>m</td>
                                        {columns?.map((col: any) => {
                                            const day = info?.hoursData?.find((w: any) => col.day === w.day)
                                            return <td
                                                style={{border: '1px solid gray'}}>{((day?.m || 0) / 60).toFixed(2)}</td>
                                        })}
                                    </tr>
                                    <tr style={{borderColor: 'transparent'}}>
                                        <td style={{border: '1px solid gray'}}>p</td>
                                        {columns?.map((col: any) => {
                                            const day = info?.hoursData?.find((w: any) => col.day === w.day)
                                            return <td
                                                style={{border: '1px solid gray'}}>{((day?.p || 0) / 60).toFixed(2)}</td>
                                        })}
                                    </tr>
                                </>
                            ))}
                            </tbody>
                        </table>
                    </div> : <div>Filtra per anno e mese</div>}
                </div>
            </div>
        </AuthLayout>
    );
}


